var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.play-st0{fill:#38A892;}\r\n\t.play-st1{fill:#38DAB6;}\r\n\t.play-st2{fill:#666666;stroke:#38DAB6;stroke-width:26.7565;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "play-st0",
    d: "M231,327.4c-8.3,0-16.6-1.5-24.5-4.3l-103.6-37.6c-37.3-13.5-56.6-54.8-43.1-92.1L97.4,89.8 c10.3-28.4,37.5-47.4,67.6-47.4c8.3,0,16.6,1.5,24.5,4.3l103.6,37.6c18.1,6.5,32.5,19.7,40.6,37.1s9,36.9,2.5,55L298.6,280 C288.3,308.4,261.2,327.4,231,327.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "play-st1",
    d: "M165,29v26.8c6.8,0,13.5,1.2,19.9,3.5l103.6,37.6c30.3,11,46.1,44.6,35.1,75l-37.6,103.6 c-8.4,23.1-30.5,38.6-55,38.6c-6.8,0-13.5-1.2-20-3.5l-103.6-37.6c-30.3-11-46.1-44.6-35.1-75L110,94.4 c8.4-23.1,30.5-38.6,55-38.6L165,29 M165,29c-34.9,0-67.6,21.5-80.2,56.2L47.3,188.8c-16.1,44.3,6.8,93.2,51.1,109.3L202,335.7 c9.6,3.5,19.4,5.1,29.1,5.1c34.9,0,67.6-21.5,80.2-56.2L348.8,181c16.1-44.3-6.8-93.2-51.1-109.3L194.1,34.2 C184.5,30.7,174.7,29,165,29L165,29z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "play-st2",
    x1: 236.9,
    y1: 397.2,
    x2: 291.9,
    y2: 452.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "play-st2",
    x1: 343.7,
    y1: 379.4,
    x2: 447.3,
    y2: 483
  }), /*#__PURE__*/React.createElement("line", {
    className: "play-st2",
    x1: 384.5,
    y1: 252.5,
    x2: 469.9,
    y2: 337.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f489764d.svg";
export { ForwardRef as ReactComponent };